//* Import libraries
import { useState, useCallback, useEffect } from "react";

//* Import react-router hooks
import { Link, useNavigate } from "react-router-dom";

//* Import components
import { List } from "../../../component/list/list";
import { Loading } from "../../../component/common/Loading";

//* Import custom hooks
import { useDemands } from "../../../hooks/demand/useDemands";

import { Demands } from "../../../hooks/demand/types/types";
import { Button, Form, Spinner, Row, Col } from "react-bootstrap";
import { Attention } from "../../../component/base/Attention";
import ModalMensagem from "../../../component/base/ModalMensagem";

var debounce = require("lodash.debounce");

export function Adaptabilidade() {
  const token = localStorage.getItem("token") || "";

  const [answers, setAnswers]: any = useState({});

  const onchangeInput=(e:any,key:any)=>{
    if(e.target.value!='' && Number.isNaN(e.target.value)){
      return;
    }

    let answers_ = { ...answers }
    answers_[key] =e.target.value==''?'': parseInt(e.target.value)
    setAnswers(answers_)
  }



  return (
    <div className="row">
      <div className="col-12">

        <div className={"py-5 px-3"}>
          <div className={"card-body"} id="card">
            <h4
              className="mt-0 header-title"
              style={{ fontSize: "2.0rem", color: "black" }}
            >
              Adaptabilidade em diversas telas
            </h4>
            <br></br>
            <br></br>
            <h4
              className="mt-0 header-title"
              style={{ fontSize: "1.5rem", color: "black" }}
            >
              Explicação da heurística:
            </h4>
            <br></br>
            <p align="justify"> <strong> Essa heurística determina que o software científico deve apresentar uma interface que permita a adaptabilidade das funções 
              para que elas possam ser realizadas independentemente do tamanho da tela do usuário. Quando um software apresentar funções que sejam inadequadas em 
              telas de tamanho variado, a documentação do software deve dizer, de forma clara, qual é o tamanho de tela recomendado. Além disso, módulos distintos podem 
              ser desenvolvidos com o intuito de serem utilizados em tamanhos de telas distintas Exemplo: Um software científico pode apresentar funções que podem 
              ser realizadas em diversos tamanhos de telas, mas as funções complexas são limitadas para serem executadas apenas em telas de 13 polegadas ou maiores </strong> </p>
            <p align="justify"> <strong> A heurística Adaptabilidade em diversas telas apresenta um critério de análise, a saber: Gestão de recursos responsivo (C1) </strong> </p>
            <br></br>
            <h4
              className="mt-0 header-title"
              style={{ fontSize: "1.5rem", color: "black" }}
            >
              Perguntas para avaliação:
            </h4>
            <br></br>


            <Form.Group className="mb-3">
              <Form.Label style={{ fontSize: 18 }} align="justify">
                P1.C1) O software apresenta funções responsivas que se adaptam ao tamanho de tela do usuário? Indique o número de funções analisadas (N) e o 
                número de funções que são responsivas (Q). <Attention />
              </Form.Label>
              <div>
                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Número de funções analisadas: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['1_1'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'1_1')
                    }}
                    required
                    
                  />
                  
                </div>

                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Número de funções que são responsivas: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['1_2'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'1_2')
                    }}
                    required
                    
                  />
                  
                </div>
              </div>
            </Form.Group>


            <br></br>
            <Form.Group className="mb-3">
              <Form.Label style={{ fontSize: 18 }} align="justify">
                P2.C1) O software apresenta em sua documentação os limites das funções serem responsivas? Indique o número de funções com limitações (N) e o 
                número de funções que apresentam os limites (Q). Exemplo: O gráfico de determinado resultado deve ser visualizado, para mostrar todas as informações 
                sem distorções, em telas de no mínimo 6 polegadas e no máximo de 43 polegas. <Attention />
              </Form.Label>
              <div>
                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Número de funções com limitações:  &nbsp; </span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['2_1'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'2_1')
                    }}
                    required
                    
                  />
                  
                </div>

                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Número de funções que apresentam os limites: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['2_2'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'2_2')
                    }}
                    required
                    
                  />
                  
                </div>
              </div>
            </Form.Group>
            <br></br>
            
            <button onClick={(e) => {

            }} className="btn btn-success btn-lg w-100">
              Gerar resultado
            </button>
            <ModalMensagem/>













          </div>
        </div>
      </div>

    </div>
  );
}
